export default {
  time: {
    crud: {
      create_overtime: "Create Overtime Request"
    },
    event: {
      clock_in: "Clock In",
      clock_out: "Clock Out",
      duty_in: "Duty In",
      training_in: "Training In",
      training_out: "Training Out",
      home_duty_in: "Home Clock In",
      duty_out: "Duty Out",
      home_duty_out: "Home Clock Out",
      break_in: "Break In",
      break_out: "Break Out",
      lunch_in: "Lunch In",
      lunch_out: "Lunch Out"
    },
    menu: {
      shifts: "Shifts",
      timesheets: "Timesheets",
      overtime_requests: "Overtime Requests",
      overtime_approval: "Overtime Approval Requests",
      employee_calendar: "Employee Calendar"
    },
    shift_types: {
      FIX: "Fix",
      FLEXIBLE: "Flexible",
      OFF_DAY: "Off Day",
      OFFDAY: "Off Day",
      HOLIDAY: "Holiday",
      WORKDAY: "Work Day",
      BREAK: "Rest Day"
    },
    overtime_approval: {
      employee: "Employee",
      workplan: "Workplan",
      request_status: "Request Status",
      reason: "Reason",
      request_time: "Requested Date",
      approval_message:
        "Do you want to approve {0}'s request for {2} minutes of <span class='red--text font-weight-bold'>{3}</span> overtime for his/her shift on {1}?",
      shift_type: {
        workday: "Workday",
        offday: "Offday work",
        holiday: "Holiday work"
      },
      overtime_approval: "Overtime Approval"
    },
    overtime_request: {
      approve_title: "Overtime Request Approval",
      add_overtime: "Add Overtime Request",
      date: "Shift Date",
      workplan: "Shift",
      overtime_in_minutes: "Overtime Duration",
      short_minute: "min",
      request_status: "Status",
      request_date: "Request Date",
      period: "Period",
      periods: {
        CLOCK_IN: "Clock In",
        CLOCK_OUT: "Clock Out",
        CLOCK_IN_OUT: "Clock In Out"
      },
      message: "{0} Do you want to approve the <b> {2} minutes overtime request for her shift on {1}  </b>"
    },
    timesheet: {
      employee: "Employee",
      employees: "Employees",
      date: "Date",
      type: "Type",
      work_plan: "Working Plan",
      shift: "Shift",
      clock_in: "Clock In",
      clock_in_title: "Clock In Time",
      late: "Late",
      reason: "Reason",
      late_title: "Late IN",
      it: "IT",
      it_title: "Identity Type",
      terminal: "Terminal",
      clock_out: "Clock Out",
      clock_out_title: "Clock Out Time",
      early: "Early",
      early_title: "Early Out",
      ewt: "EWT",
      ewt_title: "Expected Working Time",
      awt: "AWT",
      twt_title: "Total Working Time",
      twt: "TÇS",
      awt_title: "Actual Working Time",
      ot: "OT",
      ot_title: "Overtime",
      mt: "MT",
      mt_title: "Missing Time",
      name: "Employee",
      time: "Time",
      identity_type: "Identity Type",
      event_type: "Event Type",
      event_time: "Event Time",
      all_events: "All Events",
      status: "Status",
      shift_name: "Shift Name",
      branch: "Branch",
      unit: "Unit",
      team: "Team",
      jobInfo: "Job Info",
      staffNumber: "Staff Number",
      information: {
        work_day: "Work Day",
        work_day_desc: "That means the employee will come to work that day.",
        work_off: "Work Off",
        work_off_desc: "That day is the weekend holiday for the employee.",
        public_holiday: "Public Holiday",
        public_holiday_desc: "That is the public holiday for the employee.",
        did_not_come_to_work: "Did not come to the work",
        did_not_come_to_work_desc: "The employee did not come to the work despite he has a work shift for that day.",
        on_leave: "On Time Off",
        on_leave_desc: "The employee is on time off on that day.",
        calculated: "Calculated",
        calculated_desc: "That means the calculation has been done for the words colored by green.",
        not_calculated: "Not Calculated",
        not_calculated_desc: "That means the calculation hasn't been done for the words colored by red."
      },
      total: "Total"
    },
    calendar: {
      holiday: "Holiday",
      off_day: "Off Day",
      breakday: "Break Day",
      employee_overtime: "If the employee comes to work on this date, it is calculated as overtime",
      employee_off_day: "It is the employee's weekly holiday",
      employee_break_day: "It is the employee's rest day.",
      shift_loading: "Idenfit creating shifts",
      create_shift: "Create Shift",
      shift_detail: "Shift Detail",
      leave_type: "Time Off Type",
      begin_time: "Begin Time",
      end_time: "End Time",
      break_time: "Break Time",
      shift_time: "Shift Time",
      clock_in_max_overtime: "Clock In Max Overtime",
      clock_out_max_overtime: "Clock Out Max Overtime",
      lately_tolerance: "Late Tolerance",
      early_tolerance: "Early Time Off Tolerance",
      overtime: "Overtime",
      early_clock_out_tolerance: "Late Tolerance",
      lately_clock_in_tolerance: "Early Time Off Tolerance",
      max_clock_in_overtime_in_minutes: "Clock In Max Overtime",
      max_clock_out_overtime_in_minutes: "Clock Out Max Overtime",
      shift_type: "Shift Type",
      count_as_overtime: "Count as overtime",
      total_work_time: "Total Working Time",
      selectWeekends: "Weekend Days",
      selectBreaks: "Break Days",
      overtime_request: {
        approve_title: "Approving Overtime",
        add_overtime: "Request Overtime ",
        detail_overtime: "Overtime Detail",
        date: "Shift Date",
        workplan: "Shift",
        overtime_in_minutes: "Shift Time",
        request_status: "Status",
        request_date: "Request Date",
        approval_date: "Approving Date",
        period: "Period",
        history: "Approving History",
        periods: {
          CLOCK_IN: "Clock In",
          CLOCK_OUT: "Clock Out",
          CLOCK_IN_OUT: "Clock In & Out"
        },
        approved:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini onaylamak istiyor musunuz ?",
        rejected:
          "{0} <b> {1} tarihinideki vardiyası için {2} dk </b> fazla mesai talebini reddetmek istiyor musunuz ?",
        approval_to_manager: "Fazla Mesai Yöneticisine onay gitsin",
        not_approval_to_manager: "Fazla Mesai Yöneticisine onay gitmesin",
        pending_approval_manager: "Onayı Beklenen Yönetici",
        processes: {
          approved: "Approved the request",
          pending: "Pending approval",
          stopped: "Approving process stopped since the request cancelled",
          waiting: "Waiting for previous manager to approve",
          denied: "Request cancelled"
        }
      },
      multiple_shift_deleting: "Multiple Shift Deleting"
    },
    max_overtime_in_minutes_warning_message:
      "Your overtime request and assigned shift exceeds 11 hour, beucase of that your request is not created",
    totalWorkingTimeInMinutes: "Total Working Time"
  }
};
